/* eslint no-undef: 'off' */
import $ from 'jquery';

const update_cart_qty = (cart_item_key, qty, is_show, type_ship = 'standard', args = []) => {
    const ajax = themeObj.updateCartQty;
    return $.ajax({
        url: themeObj.ajaxUrl,
        method: 'POST',
        data: {
            action: ajax.action,
            nonce: ajax.nonce,
            cart_item_key,
            qty,
            type_tax: type_ship,
            is_show,
        },
        ...args
    })
}


export default {
    update_cart_qty,
}